
import {
  defineComponent, computed, PropType, ref,
} from 'vue';
import Dialog from 'primevue/dialog';
import Tooltip from 'primevue/tooltip';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import AddressMap from '@/components/data-explorer/fields/AddressMap.vue';
import { countries } from '@/types/country-language-options';
import {
  ContactAddress,
} from '@/types/data-explorer-types';
import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';

interface LatLng {
  lat: number;
  lng: number;
}

export default defineComponent({
  name: 'AddressItem',

  components: {
    SpmButton,
    Dialog,
    AddressMap,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    address: {
      type: Object as PropType<ContactAddress>,
      required: true,
    },

    showToDetailsButton: {
      type: Boolean,
      required: false,
      default: true,
    },

    showMapButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const store = useStore();

    const mapVisible = ref(false);
    const coordinate = ref<LatLng>({
      lat: 0,
      lng: 0,
    });

    // Address alias (uses address1 or a default label)
    const addressAlias = computed(() => {
      if (props.address.address1) {
        return props.address.address1.length > 40
          ? `${props.address.address1.substring(0, 40)}...`
          : props.address.address1;
      }
      return t('dataExplorer.contactFile.fields.addresses.addressLabel', { id: props.address.idShopCustomerAddress });
    });

    // Country label
    const countryLabel = computed(() => {
      if (props.address.country) {
        const country = countries.find((countryItem) => countryItem.code.toLowerCase() === props.address.country?.toLowerCase());
        return country ? country.label : props.address.country;
      }
      return null;
    });

    const openAddressDetails = async () => {
      store.dispatch('dataExplorer/openAddressFile', { idShopCustomerAddress: props.address.idShopCustomerAddress });
    };

    const openMap = async () => {
      mapVisible.value = true;
    };

    return {
      t,
      addressAlias,
      countryLabel,
      mapVisible,
      coordinate,

      openAddressDetails,
      openMap,
    };
  }
})
